import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@stoneage/App/Store/Reducers";
import "@stoneage/XDL";

// eslint-disable-next-line spire/fenced-imports
import { loadEditorTemplates } from "@insite/shell-public/EditorTemplatesLoader";

// this registers any custom editor templates that are used by custom pages/widgets
const templates = require.context("./App/EditorTemplates", true, /\.tsx$/);
const onHotTemplateReplace = loadEditorTemplates(templates);
if (module.hot) {
    module.hot.accept(templates.id, () => {
        onHotTemplateReplace(require.context("./App/EditorTemplates", true, /\.tsx$/));
    });
}

// load all widgets. Without this they won't be included in the bundle
const widgets = require.context("./App/Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)));
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// load all handlers. They could be loaded individually instead.
const handlers = require.context("./App/Handlers", true); // Recursively get all handler modifications
handlers.keys().forEach(key => handlers(key)); // Load the handler modifications.

// load all widget extensions. They could be loaded individually instead
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all widget extensions. They could be loaded individually instead
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));
